// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/block_account.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file accounts/block_account.proto.
 */
export const file_accounts_block_account: GenFile = /*@__PURE__*/
  fileDesc("ChxhY2NvdW50cy9ibG9ja19hY2NvdW50LnByb3RvEg9wcm90b3MuYWNjb3VudHMicAoTQmxvY2tBY2NvdW50UmVxdWVzdBI7CgZwYXJhbXMYASABKAsyKy5wcm90b3MuYWNjb3VudHMuQmxvY2tBY2NvdW50UmVxdWVzdC5QYXJhbXMaHAoGUGFyYW1zEhIKCmFjY291bnRfaWQYASABKAkiXgoUQmxvY2tBY2NvdW50UmVzcG9uc2USPAoGcmVzdWx0GAEgASgLMiwucHJvdG9zLmFjY291bnRzLkJsb2NrQWNjb3VudFJlc3BvbnNlLlJlc3VsdBoICgZSZXN1bHRiBnByb3RvMw");

/**
 * @generated from message protos.accounts.BlockAccountRequest
 */
export type BlockAccountRequest = Message<"protos.accounts.BlockAccountRequest"> & {
  /**
   * @generated from field: protos.accounts.BlockAccountRequest.Params params = 1;
   */
  params?: BlockAccountRequest_Params | undefined;
};

/**
 * Describes the message protos.accounts.BlockAccountRequest.
 * Use `create(BlockAccountRequestSchema)` to create a new message.
 */
export const BlockAccountRequestSchema: GenMessage<BlockAccountRequest> = /*@__PURE__*/
  messageDesc(file_accounts_block_account, 0);

/**
 * @generated from message protos.accounts.BlockAccountRequest.Params
 */
export type BlockAccountRequest_Params = Message<"protos.accounts.BlockAccountRequest.Params"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;
};

/**
 * Describes the message protos.accounts.BlockAccountRequest.Params.
 * Use `create(BlockAccountRequest_ParamsSchema)` to create a new message.
 */
export const BlockAccountRequest_ParamsSchema: GenMessage<BlockAccountRequest_Params> = /*@__PURE__*/
  messageDesc(file_accounts_block_account, 0, 0);

/**
 * @generated from message protos.accounts.BlockAccountResponse
 */
export type BlockAccountResponse = Message<"protos.accounts.BlockAccountResponse"> & {
  /**
   * @generated from field: protos.accounts.BlockAccountResponse.Result result = 1;
   */
  result?: BlockAccountResponse_Result | undefined;
};

/**
 * Describes the message protos.accounts.BlockAccountResponse.
 * Use `create(BlockAccountResponseSchema)` to create a new message.
 */
export const BlockAccountResponseSchema: GenMessage<BlockAccountResponse> = /*@__PURE__*/
  messageDesc(file_accounts_block_account, 1);

/**
 * @generated from message protos.accounts.BlockAccountResponse.Result
 */
export type BlockAccountResponse_Result = Message<"protos.accounts.BlockAccountResponse.Result"> & {
};

/**
 * Describes the message protos.accounts.BlockAccountResponse.Result.
 * Use `create(BlockAccountResponse_ResultSchema)` to create a new message.
 */
export const BlockAccountResponse_ResultSchema: GenMessage<BlockAccountResponse_Result> = /*@__PURE__*/
  messageDesc(file_accounts_block_account, 1, 0);

